import { render, staticRenderFns } from "./PseudoTimeStudyButton.vue?vue&type=template&id=10ee1de0&scoped=true"
import script from "./PseudoTimeStudyButton.vue?vue&type=script&lang=js"
export * from "./PseudoTimeStudyButton.vue?vue&type=script&lang=js"
import style0 from "./PseudoTimeStudyButton.vue?vue&type=style&index=0&id=10ee1de0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10ee1de0",
  null
  
)

export default component.exports